module.exports = __webpack_public_path__ + "static/media/b.24c71c98.svg";